'use client';
import React, { useEffect, useState } from 'react';
import { Chip, Div, Media, Modal, Select, Text } from '@pezeshk-book/ui-kit';
import { UserSearchBar } from '@layouts/search-bar';
import { FilterBoxMobileProps } from '../filter-box.props';
import CustomAccordion from '../custom-accordion';
import { UsersActions } from '@store/users/users-action';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import FilterTag from '../filter-tag';
import FilterIcon from '@icons-components/filter-icon';
import { useDebouncedCallback } from 'use-debounce';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import Button from '@elements/button';
import { LocaleTypes } from '@dictionaries-types';

const FilterBoxMobile = (props: FilterBoxMobileProps) => {
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { users } = getDictionary(lang);

  const { specialty, workTime, provinces, specialtiesType } = props;
  const { filterModal } = useSelector((state: RootState) => state.users);
  const [specialityFiltered, setSpecialityFiltered] = useState(specialty);
  const { filters } = useSelector((state: RootState) => state.users);

  const serviceType: any = {
    '1': {
      id: '1',
      route_key_affix: '1',
      title: users.index.filter.services.appointment,
    },
    '2': {
      id: '2',
      route_key_affix: '2',
      title: users.index.filter.services.consult,
    },
  };

  const closeFilterModal = () => {
    dispatch(UsersActions.switchFilterModal({ filterModal: false }));
  };

  useEffect(() => {
    if (filters?.specialtiesType?.id) {
      setSpecialityFiltered(specialty.filter((option: any) => {
        return option.type_id === Number(filters?.specialtiesType?.id);
      }));
    } else {
      setSpecialityFiltered(specialty);
    }
  }, [filters?.specialtiesType?.id]);

  const openFilterModal = () => {
    dispatch(UsersActions.switchFilterModal({ filterModal: true }));
  };

  const searchSpecialityTypeHandler = (value: any) => {
    dispatch(UsersActions.setFilterItems({ key: 'specialty', id: undefined, value: undefined }));
    const selectedTitle = specialtiesType.filter((item: any) => item.id.toString() === value);
    dispatch(UsersActions.setFilterItems({ key: 'specialtiesType', id: value, value: selectedTitle[0]?.title }));
  };

  const searchSpecialityHandler = (value: any) => {
    const selectedTitle = specialityFiltered.filter((item: any) => item.id.toString() === value);
    dispatch(UsersActions.setFilterItems({ key: 'specialty', id: value, value: selectedTitle[0]?.title }));
  };

  const searchDoctorNameHandler = useDebouncedCallback((state: string) => {
    dispatch(UsersActions.setFilterItems({ key: 'search', id: state, value: state }));
  }, 500);

  return (
    <Div className={'justify-center self-center'}>
      <Media at={'sm'}>
        <Button
          variant={'outlined'}
          onClick={openFilterModal}
          ariaLabel={users.index.filter.label}
          startAdornment={<FilterIcon/>}
          color={'tertiary'}>
          {users.index.filter.label}
        </Button>
      </Media>
      <Media at={'xs'}>
        <Button
          ariaLabel={users.index.filter.label}
          onClick={openFilterModal}
          color={'tertiary'}
          variant={'outlined'}
          startAdornment={<FilterIcon/>}
          shape={'square'}/>
      </Media>
      <Modal open={filterModal} onClose={closeFilterModal}>
        <Div className={'w-full h-full bg-white'}>
          <Div className={'flex-col overflow-scroll w-full py-5 items-center px-4'}>
            <Div className={'w-full justify-between items-center'}>
              <Text color={'grey.500'} typography={'base'}>
                {users.index.filter.title}
              </Text>
              <Chip
                value={users.index.filter.close}
                onClick={closeFilterModal}
                onDelete={closeFilterModal}
                color={'danger'}
                variant={'outlined'}
              />
            </Div>
            <Div className={'w-full gap-3 flex-wrap my-6'}>
              {Object.entries(filters).map((item: any, index) => (
                <FilterTag key={`filter_${index}`} type={item[0]} item={item[1]}/>
              ))}
            </Div>
            <Div className={'flex-col gap-4 w-full'}>
              <Div className={'w-full relative'}>
                <UserSearchBar button={false} isFilter={false} callBackText={searchDoctorNameHandler} placeholder={users.index.filter.search_doctor_placeholder}/>
              </Div>
              <Select
                className={'!z-[200]'}
                label={users.index.filter.specialities_type_label}
                autoComplete={true}
                optionsList={specialtiesType}
                value={filters?.specialtiesType?.value}
                onChange={searchSpecialityTypeHandler}
                id={'id'}
                text={'title'}
              />
              <Select
                className={'!z-[100]'}
                label={users.index.filter.speciality_label}
                autoComplete={true}
                optionsList={specialityFiltered}
                value={filters?.specialty?.value}
                onChange={searchSpecialityHandler}
                id={'id'}
                text={'title'}
              />
              <CustomAccordion
                type={'province'}
                data={provinces}
                title={users.index.filter.location}
              />
              <CustomAccordion
                type={'serviceType'}
                data={Object.values(serviceType)}
                title={filters?.serviceType?.id ? serviceType[filters?.serviceType?.id].title : users.index.filter.service_type}
              />
              <CustomAccordion
                type={'workHour'}
                data={workTime}
                title={users.index.filter.work_time}
              />
              <Button onClick={closeFilterModal}>
                {users.index.filter.button}
              </Button>
            </Div>
          </Div>
        </Div>
      </Modal>
    </Div>
  );
};

export default FilterBoxMobile;
